import { useState, useCallback } from 'react';
import API from 'api/api';
import { useFirebaseAuth } from 'domains/auth/hooks/useFirebaseAuth';

export default function useUpdateDriver() {
  const { uid } = useFirebaseAuth();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  const updateDriver = useCallback(
    async (driverId, updatedItem) => {
      if (!uid) {
        setError(new Error('User not authenticated.'));
        return;
      }
      setLoading(true);
      setError(null);
      setSuccess(false);

      try {
        await API.put(`/users/${uid}/driver/${driverId}`, updatedItem);
        setSuccess(true);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    },
    [uid]
  );

  return { updateDriver, loading, error, success };
}
